document.addEventListener('DOMContentLoaded', () => {
  const comparisonDrawerBtns = document.querySelectorAll('.comparison-widget-bike-button');
  const comparisonDrawerOverlay = document.querySelector('.comparison-widget-drawer-overlay');
  const comparisonDrawer = document.querySelector('.comparison-widget-drawer');
  const closeDrawerBtn = document.querySelector('.comparison-widget-drawer-header svg');

  // FAT-218: format prices coming from products.json (euro strings like "1999.00")
  // per the .99 rules: >= €100 without decimals ("1.999,-"), < €100 with two
  // decimals ("49,99"). Dutch number formatting, no currency symbol — matching the
  // Liquid-rendered prices ({% render 'format-price' %}) elsewhere in the widget.
  function formatComparisonPrice(value) {
    const euros = parseFloat(value);
    if (isNaN(euros)) return value != null ? String(value) : '';
    if (euros >= 100) {
      return Math.round(euros).toLocaleString('nl-NL') + ',-';
    }
    return euros.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Function to truncate text for comparison widget bike info values
  function truncateText(text, maxLength = 15) {
    if (!text) return '';
    const textStr = text.toString().trim();
    if (textStr.length <= 12) return textStr;
    if (textStr.length <= maxLength) return textStr;
    return textStr.substring(0, 12) + '...';
  }

  // Function to apply text truncation to bike info values
  function applyTextTruncation() {
    const bikeInfoValues = document.querySelectorAll('.comparison-widget-bike-info-item-value');
    bikeInfoValues.forEach(element => {
      const originalText = element.textContent;
      const truncatedText = truncateText(originalText);
      if (originalText !== truncatedText) {
        element.textContent = truncatedText;
        element.setAttribute('title', originalText); // Add tooltip with full text
      }
    });
  }

  // Apply truncation on initial load
  applyTextTruncation();

  comparisonDrawerBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      comparisonDrawerOverlay.classList.add('open');
      comparisonDrawer.classList.add('open');
    });
  });

  comparisonDrawerOverlay.addEventListener('click', () => {
    comparisonDrawerOverlay.classList.remove('open');
    comparisonDrawer.classList.remove('open');
  });

  closeDrawerBtn.addEventListener('click', () => {
    comparisonDrawerOverlay.classList.remove('open');
    comparisonDrawer.classList.remove('open');
  });

  const searchInput = document.getElementById('comparison-widget-search');
  const resultsContainer = document.getElementById('comparison-widget-search-results');
  const searchClearBtn = document.querySelector('.comparison-widget-search-input-clear');
  const collectionsList = document.querySelector('.comparison-widget-collections-list-wrapper');
  const collectionsResults = document.querySelector('.comparison-widget-collections-results');
  const collectionsResultsContent = document.querySelector('.comparison-widget-collections-results-content');
  const collectionsListElement = document.querySelector('.comparison-widget-collections-list');
  const collectionsBackBtn = document.querySelector('.comparison-widget-collections-back');

  // Handle collection clicks
  const collectionElements = document.querySelectorAll('.comparison-widget-collection');
  collectionElements.forEach(element => {
    element.addEventListener('click', () => {
      const collectionHandle = element.getAttribute('data-collection-handle');
      const collectionTitle = element.getAttribute('data-collection-title');
      if (collectionHandle) {
        loadCollectionProducts(collectionHandle, collectionTitle);
      }
    });
  });

  // Handle back button click
  collectionsBackBtn.addEventListener('click', () => {
    collectionsListElement.classList.remove('hide');
    collectionsResults.classList.remove('show');
    collectionsResultsContent.innerHTML = '';

    // Reset back button text
    const backButtonSpan = collectionsBackBtn.querySelector('span');
    if (backButtonSpan) {
      backButtonSpan.textContent = 'Back to collections';
    }
  });

  function loadCollectionProducts(collectionHandle, collectionTitle) {
    // Hide collections list and show results
    collectionsListElement.classList.add('hide');
    collectionsResults.classList.add('show');

    // Update the back button text with collection title
    const backButtonSpan = collectionsBackBtn.querySelector('span');
    if (backButtonSpan && collectionTitle) {
      backButtonSpan.textContent = collectionTitle;
    }

    // Clear search input and results
    searchInput.value = '';
    resultsContainer.innerHTML = '';
    searchClearBtn.style.visibility = 'hidden';

    // Fetch products from the collection
    fetch(`/collections/${collectionHandle}/products.json?limit=250`)
      .then(response => response.json())
      .then(data => {
        const products = data.products || [];
        console.log('PRODUCTS', products);
        const filtered = products.filter(product => {
          const availableOrContinue = product.available || product.variants.some(v => v.available === true);
          const hasTag = product.tags.includes('fatbike') || product.tags.includes('Vouwfiets') || product.tags.includes('Longtail') || product.tags.includes('E-Bike') || product.tags.includes('E-bike');
          return availableOrContinue && hasTag;
        });
        const limited = filtered.slice(0, 10);

        if (limited.length === 0) {
          collectionsResultsContent.innerHTML = '<div class="comparison-widget-search-no-results">No bikes found in this collection.</div>';
          return;
        }

        collectionsResultsContent.innerHTML = limited.map(product => `
          <div class="comparison-widget-search-result-item" data-product-id="${product.id}" data-product-handle="${product.handle}">
            <img src="${product.images[0].src}" alt="${product.title}" width="150" height="150" loading="lazy" />
            
            <div class="comparison-widget-bike-content">
              <p class="comparison-widget-bike-title">${product.title}</p>
              
              <div class="comparison-widget-bike-price">
                <span class="comparison-widget-bike-price-actual${product.variants[0].compare_at_price && product.variants[0].compare_at_price > product.variants[0].price ? ' comparison-widget-bike-price-sale' : ''}">${formatComparisonPrice(product.variants[0].price)}</span>
                ${product.variants[0].compare_at_price && product.variants[0].compare_at_price > product.variants[0].price ? `<span class="comparison-widget-bike-price-compare">${formatComparisonPrice(product.variants[0].compare_at_price)}</span>` : ''}
              </div>
            </div>
          </div>
        `).join('');
      })
      .catch(error => {
        console.error('Error loading collection products:', error);
        collectionsResultsContent.innerHTML = '<div class="comparison-widget-search-no-results">Error loading products.</div>';
      });
  }

  searchClearBtn.addEventListener('click', () => {
    searchInput.value = '';
    resultsContainer.innerHTML = '';
    searchClearBtn.style.visibility = 'hidden';
    collectionsList.style.display = 'grid';
    // Reset collections view
    collectionsListElement.classList.remove('hide');
    collectionsResults.classList.remove('show');
    collectionsResultsContent.innerHTML = '';

    // Reset back button text
    const backButtonSpan = collectionsBackBtn.querySelector('span');
    if (backButtonSpan) {
      backButtonSpan.textContent = 'Back to collections';
    }
  });

  // Function to handle product selection
  function handleProductSelection(productHandle) {
    // Close the drawer
    comparisonDrawerOverlay.classList.remove('open');
    comparisonDrawer.classList.remove('open');

    // Make request to section rendering API
    fetch(`/products/${productHandle}?section_id=comparison-widget-selected-bike`)
      .then(response => response.text())
      .then(html => {
        // Find the comparison widget bike compare wrapper
        const compareWrapper = document.querySelector('.comparison-widget-bike-compare-wrapper');
        if (compareWrapper) {
          compareWrapper.innerHTML = html;

          // Make all comparison-widget-bike-info-wrapper elements display flex
          const infoWrappers = document.querySelectorAll('.comparison-widget-bike-info-wrapper');
          infoWrappers.forEach(wrapper => {
            wrapper.style.display = 'flex';
          });

          // Apply text truncation to newly loaded content
          applyTextTruncation();
        }
      })
      .catch(error => {
        console.error('Error loading selected bike:', error);
      })
      .finally(() => {
        // Remove and re-add listeners to comparisonDrawerBtns
        comparisonDrawerBtns.forEach(btn => {
          btn.replaceWith(btn.cloneNode(true));
        });
        // Re-query buttons and re-add listeners
        const newBtns = document.querySelectorAll('.comparison-widget-bike-button');
        newBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            comparisonDrawerOverlay.classList.add('open');
            comparisonDrawer.classList.add('open');
          });
        });
      });
  }

  // Add event delegation for search result items
  function addProductSelectionListeners(container) {
    container.addEventListener('click', (e) => {
      const resultItem = e.target.closest('.comparison-widget-search-result-item');
      if (resultItem) {
        const productHandle = resultItem.getAttribute('data-product-handle');
        if (productHandle) {
          handleProductSelection(productHandle);
        }
      }
    });
  }

  // Add listeners to both search results and collection results
  addProductSelectionListeners(resultsContainer);
  addProductSelectionListeners(collectionsResultsContent);

  let timer;
  searchInput.addEventListener('input', function () {
    clearTimeout(timer);
    const query = searchInput.value.trim();
    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      searchClearBtn.style.visibility = 'hidden';
      collectionsList.style.display = 'grid';
      // Reset collections view
      collectionsListElement.classList.remove('hide');
      collectionsResults.classList.remove('show');
      collectionsResultsContent.innerHTML = '';

      // Reset back button text
      const backButtonSpan = collectionsBackBtn.querySelector('span');
      if (backButtonSpan) {
        backButtonSpan.textContent = 'Back to collections';
      }
      return;
    }
    searchClearBtn.style.visibility = 'visible';
    collectionsList.style.display = 'none';
    // Hide collections results when searching
    collectionsResults.classList.remove('show');
    collectionsResultsContent.innerHTML = '';
    timer = setTimeout(function () {
      fetch(`/search?type=product&q=${encodeURIComponent(query)}&view=comparison-ajax`)
        .then(response => response.json())
        .then(data => {
          const products = data.products || [];
          const filtered = products.filter(product => {
            const availableOrContinue = product.available || product.continue_selling;
            const hasTag = product.tags.includes('fatbike') || product.tags.includes('Vouwfiets') || product.tags.includes('Longtail') || product.tags.includes('E-Bike') || product.tags.includes('E-bike');
            return availableOrContinue && hasTag;
          });
          const limited = filtered.slice(0, 10);
          if (limited.length === 0) {
            resultsContainer.innerHTML = '<div class="comparison-widget-search-no-results">No bikes found.</div>';
            return;
          }
          resultsContainer.innerHTML = limited.map(product => {
            const hasCompare = product.compare_at_price_max && product.compare_at_price_max !== '0.00' && product.compare_at_price_max !== product.price_min;
            return `
              <div class="comparison-widget-search-result-item" data-product-id="${product.id}" data-product-handle="${product.handle}">
                <img src="${product.featured_image}" alt="${product.title}" width="150" height="150" loading="lazy" />
                <div class="comparison-widget-bike-content">
                  <p class="comparison-widget-bike-title">${product.title}</p>
                  <div class="comparison-widget-bike-price">
                    <span class="comparison-widget-bike-price-actual${hasCompare ? ' comparison-widget-bike-price-sale' : ''}">${formatComparisonPrice(product.price_min)}</span>
                    ${hasCompare ? `<span class="comparison-widget-bike-price-compare">${formatComparisonPrice(product.compare_at_price_max)}</span>` : ''}
                  </div>
                </div>
              </div>
            `;
          }).join('');
        });
    }, 300);
  });
});